import React, { useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import useDialogStyles from '../TransferTicketModalCustom/dialogStyles';

export default function ContactNotesEditModal({ open, onClose, note, onSave }) {
  const classes = useDialogStyles({ width: 400 });
  const [editedNote, setEditedNote] = useState(note);

  const handleSave = () => {
    onSave(editedNote); // Chama a função onSave com a nota editada
    onClose(); // Fecha o diálogo de edição
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      classes={{ paper: classes.paper }}
      aria-labelledby="edit-note-title"
    >
      <div className={classes.header}>
        <h2 id="edit-note-title" className={classes.title}>Editar observação</h2>
      </div>
      <DialogContent className={classes.content}>
        <div className={classes.field}>
          <span className={classes.label}>Observação</span>
          <TextField
            fullWidth
            multiline
            rows={4}
            variant="outlined"
            value={note}
            onChange={(e) => setEditedNote(e.target.value)}
            inputProps={{ 'aria-label': 'Observação' }}
          />
        </div>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <Button onClick={onClose} className={classes.cancel}>
          Cancelar
        </Button>
        <Button
          onClick={handleSave}
          color="primary"
          variant="contained"
          className={classes.confirm}
        >
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
